(() => {
  const norm = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const replaceExact = (from, to, root = document) => {
    root.querySelectorAll('h1,h2,h3,h4,p,span,strong,a,button').forEach((el) => {
      if (norm(el.textContent) === from) el.textContent = to;
    });
  };

  const setRoute = (route, expectedTexts, meta, title, copy, href) => {
    if (!route) return;
    const current = norm(route.textContent);
    const legacy = expectedTexts.some((text) => current.includes(text));
    if (!legacy) return;
    const metaEl = route.querySelector('.bn-start-route__meta span');
    const titleEl = route.querySelector('.bn-start-route__title');
    const copyEl = route.querySelector('.bn-start-route__copy');
    if (metaEl) metaEl.textContent = meta;
    if (titleEl) titleEl.textContent = title;
    if (copyEl) copyEl.textContent = copy;
    route.setAttribute('href', href);
  };

  const hideLegacySection = (headingText) => {
    document.querySelectorAll('.shopify-section').forEach((wrapper) => {
      const heading = wrapper.querySelector('h2');
      if (heading && norm(heading.textContent) === headingText) {
        wrapper.hidden = true;
        wrapper.setAttribute('aria-hidden', 'true');
        wrapper.dataset.bnReviewHidden = 'true';
      }
    });
  };

  const apply = () => {
    replaceExact('ZRÓB TO SAMA. WYJDZIE.', 'ZRÓB TO. WYJDZIE.');

    const start = document.querySelector('[id^="BNStart-"]');
    if (start) {
      const routes = [...start.querySelectorAll('.bn-start-route')];
      setRoute(
        routes[0],
        ['CHCĘ MANICURE HYBRYDOWY', 'Zaczynam od Zera', 'ZACZYNAM OD ZERA'],
        'NIE MAM LAMPY',
        'START OD ZERA',
        'Zacznij od krótkiej listy tego, czego naprawdę potrzebujesz.',
        '/pages/zacznij#bn-start-needs'
      );
      setRoute(
        routes[1],
        ['CHCĘ PRZEDŁUŻYĆ PAZNOKCIE', 'MAM LAMPĘ'],
        'MAM LAMPĘ',
        'MAM LAMPĘ',
        'Masz sprzęt. Przejdź od razu do produktów i procesu.',
        '/pages/zacznij#bn-start-systems'
      );
    }

    replaceExact(
      'Pokazujemy tylko wybory, które mogą realnie wpłynąć na drop albo powrót koloru.',
      'Głosuj na kolory i powroty, które chcesz zobaczyć w kolejnych dropach.'
    );
    replaceExact(
      'Głos zapisujemy na stronie społeczności. Wynik publikujemy razem z decyzją.',
      'Wynik zobaczysz razem z decyzją.'
    );
    replaceExact(
      'Wrzuć stylizację, oznacz BAD NAILZ i wejdź do żywego świata marki. Realna praca, realna autorka, jasna zgoda na publikację.',
      'Wrzuć stylizację, oznacz BAD NAILZ i pokaż swoje B.'
    );

    replaceExact('PIERWSZA WIESZ O NOWOŚCIACH', 'NIE PRZEGAP NOWOŚCI');
    replaceExact('NOWE KOLORY WIDZISZ PIERWSZA.', 'NOWE KOLORY PROSTO NA MAILA.');
    replaceExact(
      'Dropy, powroty i wyniki głosowań. Jeden zapis, zero kupowania uwagi rabatem.',
      'Dropy, powroty i wyniki głosowań. Jeden zapis i wiesz, co dzieje się dalej.'
    );

    replaceExact(
      'ZRÓB TO SAMA · WYJDZIE · REALNY KOLOR · ZERO ZGADYWANIA',
      'ZRÓB TO · WYJDZIE · WYBIERZ KOLOR · ZACZNIJ PO SWOJEMU'
    );
    replaceExact('Realny kolor, prosta ścieżka i zero salonowego egzaminu.', 'Kolor, prosty start i wszystko, czego potrzebujesz po drodze.');

    hideLegacySection('TAK WYGLĄDA W REALU');
    hideLegacySection('CO MOŻESZ OD NAS WYMAGAĆ?');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
  window.addEventListener('load', apply, { once: true });
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:reorder', apply);
  window.setTimeout(apply, 500);
})();
